import { isString } from './types'

const encodeUriSegment = (segment) => segment.replace(/\//g, '_fs_').replace(/ /g, '%20')
const decodeUriSegment = (segment) => segment.replace(/_fs_/g, '/').replace(/%20/g, ' ')

const contentAssetPath = (path) => {
    if (window.location.hostname.match(/localhost/i)) {
        return 'contentassetimages/suncare-finder/'.concat(path)
    } else if (isString(path) && window.hasOwnProperty('composed_gift_guide_content_asset_path')) {
        return window.composed_suncare_finder_content_asset_path.concat(path)
    }
}

export {
    encodeUriSegment,
    decodeUriSegment,
    contentAssetPath,
}


// WEBPACK FOOTER //
// ./development/js/utiliites/index.js